var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 16C36.5523 16 37 15.5523 37 15C37 14.4477 36.5523 14 36 14L36 16ZM6.29289 14.2929C5.90237 14.6834 5.90237 15.3166 6.29289 15.7071L12.6569 22.0711C13.0474 22.4616 13.6805 22.4616 14.0711 22.0711C14.4616 21.6805 14.4616 21.0474 14.0711 20.6569L8.41421 15L14.0711 9.34315C14.4616 8.95262 14.4616 8.31946 14.0711 7.92893C13.6805 7.53841 13.0474 7.53841 12.6569 7.92893L6.29289 14.2929ZM36 14L7 14L7 16L36 16L36 14Z",
    fill: "#B92250"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/backIcon.fcc489b7.svg";
export { ForwardRef as ReactComponent };